// @flow
import * as React from 'react';
import ReactDOM from 'react-dom';

interface Props {
 message?: string,
}

const Error = ({ message = 'unknown error' }: Props): React.Element<any> => (
  <div className="App">
    <div className="App-header">
      <h2>Something went wrong</h2>
      <p className="App-intro">
        {message}
      </p>
    </div>
  </div>
);

const RenderPage = (message: string) => {
  ReactDOM.render(<Error message={message} />, document.getElementById('root'));
};

export default RenderPage;



// WEBPACK FOOTER //
// ./src/scenes/Error/Error.js